// src/App.tsx
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ErrorBoundary from './components/ErrorBoundary';
import Layout from './components/Layout';
import SEOHead from './components/SEOHead';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import About from './pages/About';
import Engineers from './pages/Engineers';
import Articles from './pages/Articles';
import ArticleDetail from './pages/ArticleDetail';
import Contact from './pages/Contact';
import Projects from './pages/Projects';
import ProjectDetail from './pages/ProjectDetail';
import CloverAppWorking from './components/clover/CloverAppWorking';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Scheduling from './pages/Scheduling';
import SignAgreement from './pages/SignAgreement';
import LearningSignup from './pages/LearningSignup';
import NotFound from './pages/NotFound';

const App: React.FC = () => {
  return (
      <ErrorBoundary>
        <Router>
          <ScrollToTop />
          <SEOHead />
          <Routes>
            {/* Main site routes with Layout */}
            <Route path="/" element={<Layout><Home /></Layout>} />
            <Route path="/about" element={<Layout><About /></Layout>} />
            <Route path="/engineers" element={<Layout><Engineers /></Layout>} />
            <Route path="/articles" element={<Layout><Articles /></Layout>} />
            <Route path="/articles/:slug" element={<Layout><ArticleDetail /></Layout>} />
            <Route path="/contact" element={<Layout><Contact /></Layout>} />
            <Route path="/projects" element={<Layout><Projects /></Layout>} />
            <Route path="/projects/:slug" element={<Layout><ProjectDetail /></Layout>} />
            <Route path="/privacy" element={<Layout><PrivacyPolicy /></Layout>} />
            <Route path="/scheduling" element={<Layout><Scheduling /></Layout>} />
            {/* Client-facing contract signing. The UUID token in the URL is the
                credential, so this route is intentionally public. */}
            <Route path="/sign/:token" element={<Layout><SignAgreement /></Layout>} />

            {/* Standalone pages without Layout — these are the whole of their
                subdomain and bring their own header/footer. */}
            <Route path="/learning" element={<LearningSignup />} />

            {/* Admin routes without Layout */}
            <Route path="/admin/clover/*" element={<CloverAppWorking />} />
            
            {/* 404 with Layout */}
            <Route path="*" element={<Layout><NotFound /></Layout>} />
          </Routes>
        </Router>
      </ErrorBoundary>
  );
}

export default App;
// import React from 'react';
// import { 
//   Box, 
//   Text, 
//   Button, 
//   VStack, 
//   HStack, 
//   Heading,
//   Grid
// } from '@chakra-ui/react';

// function App() {
//   return (
//     <Box bg="black" minH="100vh" w="100vw" maxW="100vw" overflowX="hidden" color="white">
//       {/* Header - Simplified Navigation */}
//       <Box 
//         position="sticky"
//         top={0}
//         zIndex={10}
//         bg="black"
//         borderBottom="1px solid"
//         borderColor="gray.800"
//       >
//         <Box px={8} py={4}>
//           <HStack justify="space-between" align="center">
//             {/* Logo */}
//             <HStack spacing={2}>
//               <Text fontSize="2xl" fontWeight="bold" color="white" letterSpacing="-0.02em">
//                 clover ridge
//               </Text>
//               <Text fontSize="sm" color="gray.400" fontWeight="normal">
//                 technologies
//               </Text>
//             </HStack>

//             {/* Simplified Navigation */}
//             <HStack spacing={8}>
//               <Text color="white" fontSize="sm" fontWeight="medium">Home</Text>
//               <Text color="white" fontSize="sm" fontWeight="medium">About</Text>
//               <Text color="white" fontSize="sm" fontWeight="medium">Engineers</Text>
//               <Text color="white" fontSize="sm" fontWeight="medium">Articles</Text>
//               <Button 
//                 bg="green.500" 
//                 color="white" 
//                 size="sm"
//                 px={6}
//                 fontSize="sm"
//                 fontWeight="medium"
//                 _hover={{ bg: "green.600" }}
//               >
//                 Contact
//               </Button>
//             </HStack>
//           </HStack>
//         </Box>
//       </Box>

//       {/* Hero Section with Image */}
//       <Box 
//         position="relative"
//         minH="70vh"
//         display="flex"
//         alignItems="center"
//         overflow="hidden"
//         bg="black"
//       >
//         {/* Background Pattern */}
//         <Box
//           position="absolute"
//           top={0}
//           left={0}
//           right={0}
//           bottom={0}
//           opacity={0.1}
//           backgroundImage="radial-gradient(circle at 20% 50%, green.500 1px, transparent 1px), radial-gradient(circle at 80% 30%, green.500 1px, transparent 1px), radial-gradient(circle at 40% 80%, green.500 1px, transparent 1px)"
//           backgroundSize="100px 100px, 150px 150px, 80px 80px"
//         />

//         <Box px={4} w="100%">
//           <Grid templateColumns="1fr 1fr" gap={16} alignItems="center" maxW="5xl" mx="auto">
//             {/* Left Side - Text */}
//             <VStack align="start" spacing={8}>
//               <VStack align="start" spacing={6}>
//                 <Heading 
//                   size="4xl" 
//                   fontWeight="bold"
//                   lineHeight="1.1"
//                   letterSpacing="-0.02em"
//                   textTransform="uppercase"
//                 >
//                   ENGINEERING SYSTEMS THAT
//                   <br />
//                   HAVE YOU COVERED
//                 </Heading>
//                 <Text fontSize="lg" color="gray.300" lineHeight="1.6" maxW="500px">
//                   Building scalable solutions is what we do, and it's what we do best. Web apps, APIs, or 
//                   infrastructure, our engineering systems deliver thousands of requests, processing every 
//                   second to scale and perform with precision.
//                 </Text>
//               </VStack>
//             </VStack>

//             {/* Right Side - Hero Image */}
//             <Box 
//               h="400px" 
//               bg="gray.900"
//               border="1px solid"
//               borderColor="gray.700"
//               display="flex"
//               alignItems="center"
//               justifyContent="center"
//               position="relative"
//               overflow="hidden"
//             >
//               {/* Tech Pattern Overlay */}
//               <Box
//                 position="absolute"
//                 top={0}
//                 left={0}
//                 right={0}
//                 bottom={0}
//                 opacity={0.3}
//                 backgroundImage="linear-gradient(45deg, transparent 30%, green.900 50%, transparent 70%)"
//               />
//               <Box
//                 position="absolute"
//                 top="20%"
//                 right="20%"
//                 w="60px"
//                 h="60px"
//                 border="2px solid"
//                 borderColor="green.500"
//                 transform="rotate(45deg)"
//               />
//               <Box
//                 position="absolute"
//                 bottom="30%"
//                 left="25%"
//                 w="40px"
//                 h="40px"
//                 bg="green.500"
//                 opacity={0.7}
//                 borderRadius="full"
//               />
//               <Text color="gray.400" fontSize="sm" textAlign="center">
//                 Engineering Excellence
//                 <br />
//                 Visualization
//               </Text>
//             </Box>
//           </Grid>
//         </Box>
//       </Box>

//       {/* Solutions Grid - 4 Boxes with Navigation Links */}
//       <Box py={20} px={4}>
//         <Grid templateColumns="repeat(2, 1fr)" gap={6} maxW="5xl" mx="auto">
//           {/* Box 1 - Web Development */}
//           <Box 
//             bg="gray.900"
//             p={12}
//             border="1px solid"
//             borderColor="gray.700"
//             position="relative"
//             _hover={{ bg: "gray.800" }}
//             transition="all 0.3s"
//             cursor="pointer"
//           >
//             <VStack align="start" spacing={6}>
//               <Box 
//                 w={12} 
//                 h={12} 
//                 border="2px solid"
//                 borderColor="white"
//                 display="flex"
//                 alignItems="center"
//                 justifyContent="center"
//                 fontSize="xl"
//               >
//                 ⚡
//               </Box>
//               <VStack align="start" spacing={4}>
//                 <Heading size="xl" textTransform="uppercase" letterSpacing="wide">
//                   WEB DEVELOPMENT
//                 </Heading>
//                 <Text color="gray.300" lineHeight="1.6">
//                   Give your users seamless experiences and a full view of functionality 
//                   with our modern web applications. React, Django, and responsive design 
//                   deliver real-time data to support your business growth.
//                 </Text>
//               </VStack>
//               <Button 
//                 bg="green.500" 
//                 color="white" 
//                 size="sm"
//                 rightIcon={<Text>→</Text>}
//                 _hover={{ bg: "green.600" }}
//                 onClick={() => window.location.href = '/projects'}
//               >
//                 View Projects
//               </Button>
//             </VStack>
//           </Box>

//           {/* Box 2 - Cloud Infrastructure */}
//           <Box 
//             bg="gray.900"
//             p={12}
//             border="1px solid"
//             borderColor="gray.700"
//             position="relative"
//             _hover={{ bg: "gray.800" }}
//             transition="all 0.3s"
//             cursor="pointer"
//           >
//             <VStack align="start" spacing={6}>
//               <Box 
//                 w={12} 
//                 h={12} 
//                 border="2px solid"
//                 borderColor="white"
//                 display="flex"
//                 alignItems="center"
//                 justifyContent="center"
//                 fontSize="xl"
//               >
//                 ☁️
//               </Box>
//               <VStack align="start" spacing={4}>
//                 <Heading size="xl" textTransform="uppercase" letterSpacing="wide">
//                   CLOUD INFRASTRUCTURE
//                 </Heading>
//                 <Text color="gray.300" lineHeight="1.6">
//                   Our cloud systems deploy and integrate in minutes, alerting you of 
//                   performance metrics and scaling as early as possible. Detect, 
//                   monitor and optimize infrastructure in real-time for informed, efficient 
//                   operations.
//                 </Text>
//               </VStack>
//               <Button 
//                 bg="green.500" 
//                 color="white" 
//                 size="sm"
//                 rightIcon={<Text>→</Text>}
//                 _hover={{ bg: "green.600" }}
//                 onClick={() => window.location.href = '/projects'}
//               >
//                 View Infrastructure
//               </Button>
//             </VStack>
//           </Box>

//           {/* Box 3 - Technical Articles */}
//           <Box 
//             bg="gray.900"
//             p={12}
//             border="1px solid"
//             borderColor="gray.700"
//             position="relative"
//             _hover={{ bg: "gray.800" }}
//             transition="all 0.3s"
//             cursor="pointer"
//           >
//             <VStack align="start" spacing={6}>
//               <Box 
//                 w={12} 
//                 h={12} 
//                 border="2px solid"
//                 borderColor="white"
//                 display="flex"
//                 alignItems="center"
//                 justifyContent="center"
//                 fontSize="xl"
//               >
//                 📝
//               </Box>
//               <VStack align="start" spacing={4}>
//                 <Heading size="xl" textTransform="uppercase" letterSpacing="wide">
//                   TECHNICAL ARTICLES
//                 </Heading>
//                 <Text color="gray.300" lineHeight="1.6">
//                   Deep dives into engineering challenges, best practices, and lessons learned. 
//                   From API design to deployment strategies, we share insights from real-world 
//                   projects and cutting-edge development techniques.
//                 </Text>
//               </VStack>
//               <Button 
//                 bg="green.500" 
//                 color="white" 
//                 size="sm"
//                 rightIcon={<Text>→</Text>}
//                 _hover={{ bg: "green.600" }}
//                 onClick={() => window.location.href = '/articles'}
//               >
//                 Read Articles
//               </Button>
//             </VStack>
//           </Box>

//           {/* Box 4 - Project Portfolio */}
//           <Box 
//             bg="gray.900"
//             p={12}
//             border="1px solid"
//             borderColor="gray.700"
//             position="relative"
//             _hover={{ bg: "gray.800" }}
//             transition="all 0.3s"
//             cursor="pointer"
//           >
//             <VStack align="start" spacing={6}>
//               <Box 
//                 w={12} 
//                 h={12} 
//                 border="2px solid"
//                 borderColor="white"
//                 display="flex"
//                 alignItems="center"
//                 justifyContent="center"
//                 fontSize="xl"
//               >
//                 🚀
//               </Box>
//               <VStack align="start" spacing={4}>
//                 <Heading size="xl" textTransform="uppercase" letterSpacing="wide">
//                   PROJECT PORTFOLIO
//                 </Heading>
//                 <Text color="gray.300" lineHeight="1.6">
//                   Explore our completed projects and case studies. From e-commerce platforms 
//                   to enterprise APIs, see how we've helped teams build scalable, reliable 
//                   systems that drive business results.
//                 </Text>
//               </VStack>
//               <Button 
//                 bg="green.500" 
//                 color="white" 
//                 size="sm"
//                 rightIcon={<Text>→</Text>}
//                 _hover={{ bg: "green.600" }}
//                 onClick={() => window.location.href = '/projects'}
//               >
//                 View Portfolio
//               </Button>
//             </VStack>
//           </Box>
//         </Grid>
//       </Box>

//       {/* Why Choose Us - Stats Section */}
//       <Box py={24} px={4}>
//         <VStack spacing={20}>
//           <Heading size="3xl" textTransform="uppercase" letterSpacing="wide" textAlign="left" w="100%" maxW="5xl" mx="auto">
//             WHY CLOVER RIDGE TECHNOLOGIES?
//           </Heading>
          
//           <Grid templateColumns="repeat(4, 1fr)" gap={12} maxW="5xl" mx="auto">
//             {/* Stat 1 */}
//             <VStack align="start" spacing={4}>
//               <HStack>
//                 <Box w={3} h={3} bg="green.500" borderRadius="full" />
//                 <Heading size="4xl" color="white" fontWeight="bold">5+</Heading>
//               </HStack>
//               <VStack align="start" spacing={2}>
//                 <Text fontSize="lg" fontWeight="bold" textTransform="uppercase" letterSpacing="wide">
//                   YEARS OF CODE CRAFT
//                 </Text>
//                 <Text color="gray.300" fontSize="sm" lineHeight="1.6">
//                   Our engineering heritage is steeped 
//                   in software science. A combination 
//                   of experience, innovation, and a 
//                   fierce drive to build solutions for 
//                   modern problems make us a 
//                   reliable technology partner.
//                 </Text>
//               </VStack>
//             </VStack>

//             {/* Stat 2 */}
//             <VStack align="start" spacing={4}>
//               <HStack>
//                 <Box w={3} h={3} bg="green.500" borderRadius="full" />
//                 <Heading size="4xl" color="white" fontWeight="bold">100%</Heading>
//               </HStack>
//               <VStack align="start" spacing={2}>
//                 <Text fontSize="lg" fontWeight="bold" textTransform="uppercase" letterSpacing="wide">
//                   UPTIME GUARANTEED
//                 </Text>
//                 <Text color="gray.300" fontSize="sm" lineHeight="1.6">
//                   Most systems monitor in one 
//                   direction or provide partial 
//                   coverage in production. Our systems combine 
//                   reliable infrastructure in one solution 
//                   for full awareness of what's 
//                   happening all around you, all 
//                   year round.
//                 </Text>
//               </VStack>
//             </VStack>

//             {/* Stat 3 */}
//             <VStack align="start" spacing={4}>
//               <HStack>
//                 <Box w={3} h={3} bg="green.500" borderRadius="full" />
//                 <Heading size="4xl" color="white" fontWeight="bold">50+</Heading>
//               </HStack>
//               <VStack align="start" spacing={2}>
//                 <Text fontSize="lg" fontWeight="bold" textTransform="uppercase" letterSpacing="wide">
//                   PROJECTS DELIVERED
//                 </Text>
//                 <Text color="gray.300" fontSize="sm" lineHeight="1.6">
//                   We focus on development as a 
//                   crucial piece of a full solution. 
//                   Our systems slot seamlessly into 
//                   your tech stack, with an 
//                   interoperable interface that 
//                   adapts to your needs and setup.
//                 </Text>
//               </VStack>
//             </VStack>

//             {/* Stat 4 */}
//             <VStack align="start" spacing={4}>
//               <HStack>
//                 <Box w={3} h={3} bg="green.500" borderRadius="full" />
//                 <Heading size="4xl" color="white" fontWeight="bold">24/7</Heading>
//               </HStack>
//               <VStack align="start" spacing={2}>
//                 <Text fontSize="lg" fontWeight="bold" textTransform="uppercase" letterSpacing="wide">
//                   SUPPORT AVAILABLE
//                 </Text>
//                 <Text color="gray.300" fontSize="sm" lineHeight="1.6">
//                   We're proud of our engineering, and 
//                   prouder still of our legacy of 
//                   innovation. We write, test, and deploy 
//                   everything we build. Meticulous 
//                   development keeps our solutions at 
//                   the cutting edge.
//                 </Text>
//               </VStack>
//             </VStack>
//           </Grid>
//         </VStack>
//       </Box>

//       {/* Our Technologies - React/Django */}
//       <Box py={24} px={4} textAlign="center">
//         <VStack spacing={16}>
//           <VStack spacing={4}>
//             <Heading size="3xl" textTransform="uppercase" letterSpacing="wide">
//               OUR TECHNOLOGIES
//             </Heading>
//             <Text fontSize="lg" color="gray.300" maxW="4xl">
//               Frontend, backend, or infrastructure, when it comes to modern development, our specialized engineering solutions are a cut above the rest.
//             </Text>
//           </VStack>

//           <Grid templateColumns="repeat(2, 1fr)" gap={0} maxW="5xl" mx="auto">
//             {/* Tech 1 */}
//             <Box p={16} border="1px solid" borderColor="gray.800" bg="gray.900">
//               <VStack spacing={8}>
//                 <Heading size="4xl" fontWeight="bold" letterSpacing="wide">
//                   REACT
//                 </Heading>
//                 <Text color="gray.300" textAlign="center" lineHeight="1.6">
//                   Modern frontend framework, React has lightning-
//                   fast rendering speed and extensive component 
//                   capability.
//                 </Text>
//                 <VStack align="start" spacing={3} w="100%">
//                   <HStack>
//                     <Box w={2} h={2} bg="green.500" borderRadius="full" />
//                     <Text fontSize="sm" color="gray.300">Component-based architecture</Text>
//                   </HStack>
//                   <HStack>
//                     <Box w={2} h={2} bg="green.500" borderRadius="full" />
//                     <Text fontSize="sm" color="gray.300">Virtual DOM for performance</Text>
//                   </HStack>
//                   <HStack>
//                     <Box w={2} h={2} bg="green.500" borderRadius="full" />
//                     <Text fontSize="sm" color="gray.300">Rich ecosystem and tooling</Text>
//                   </HStack>
//                   <HStack>
//                     <Box w={2} h={2} bg="green.500" borderRadius="full" />
//                     <Text fontSize="sm" color="gray.300">TypeScript integration for reliability</Text>
//                   </HStack>
//                 </VStack>
//               </VStack>
//             </Box>

//             {/* Tech 2 */}
//             <Box p={16} border="1px solid" borderColor="gray.800" bg="gray.900">
//               <VStack spacing={8}>
//                 <Heading size="4xl" fontWeight="bold" letterSpacing="wide">
//                   DJANGO
//                 </Heading>
//                 <Text color="gray.300" textAlign="center" lineHeight="1.6">
//                   Django offers robust backends, scalability, 
//                   and enterprise-grade security in a powerful but lightweight 
//                   framework.
//                 </Text>
//                 <VStack align="start" spacing={3} w="100%">
//                   <HStack>
//                     <Box w={2} h={2} bg="green.500" borderRadius="full" />
//                     <Text fontSize="sm" color="gray.300">REST API development</Text>
//                   </HStack>
//                   <HStack>
//                     <Box w={2} h={2} bg="green.500" borderRadius="full" />
//                     <Text fontSize="sm" color="gray.300">Database ORM and migrations</Text>
//                   </HStack>
//                   <HStack>
//                     <Box w={2} h={2} bg="green.500" borderRadius="full" />
//                     <Text fontSize="sm" color="gray.300">Built-in security features</Text>
//                   </HStack>
//                   <HStack>
//                     <Box w={2} h={2} bg="green.500" borderRadius="full" />
//                     <Text fontSize="sm" color="gray.300">Scalable architecture patterns</Text>
//                   </HStack>
//                 </VStack>
//               </VStack>
//             </Box>
//           </Grid>
//         </VStack>
//       </Box>

//       {/* Markets We Serve */}
//       <Box py={24} px={4}>
//         <VStack spacing={16}>
//           <VStack spacing={6} textAlign="left" w="100%" maxW="5xl" mx="auto">
//             <Heading size="3xl" textTransform="uppercase" letterSpacing="wide">
//               MARKETS WE SERVE
//             </Heading>
//             <Text fontSize="lg" color="gray.300" maxW="3xl">
//               Our engineering systems deliver high-quality solutions, rapid development, and the 
//               best possible performance to scale and adapt as requirements emerge.
//             </Text>
//           </VStack>

//           <Grid templateColumns="repeat(6, 1fr)" gap={0} maxW="5xl" mx="auto">
//             {/* Market Icons */}
//             <VStack spacing={4} p={8} borderRight="1px solid" borderColor="gray.800">
//               <Box fontSize="2xl">🏢</Box>
//               <HStack>
//                 <Box w={2} h={2} bg="green.500" borderRadius="full" />
//                 <Text fontSize="sm" fontWeight="bold" color="white" textTransform="uppercase" letterSpacing="wide" textAlign="center">
//                   STARTUPS
//                 </Text>
//               </HStack>
//             </VStack>
            
//             <VStack spacing={4} p={8} borderRight="1px solid" borderColor="gray.800">
//               <Box fontSize="2xl">🏭</Box>
//               <HStack>
//                 <Box w={2} h={2} bg="green.500" borderRadius="full" />
//                 <Text fontSize="sm" fontWeight="bold" color="white" textTransform="uppercase" letterSpacing="wide" textAlign="center">
//                   ENTERPRISE
//                 </Text>
//               </HStack>
//             </VStack>

//             <VStack spacing={4} p={8} borderRight="1px solid" borderColor="gray.800">
//               <Box fontSize="2xl">💰</Box>
//               <HStack>
//                 <Box w={2} h={2} bg="green.500" borderRadius="full" />
//                 <Text fontSize="sm" fontWeight="bold" color="white" textTransform="uppercase" letterSpacing="wide" textAlign="center">
//                   FINTECH
//                 </Text>
//               </HStack>
//             </VStack>

//             <VStack spacing={4} p={8} borderRight="1px solid" borderColor="gray.800">
//               <Box fontSize="2xl">🛒</Box>
//               <HStack>
//                 <Box w={2} h={2} bg="green.500" borderRadius="full" />
//                 <Text fontSize="sm" fontWeight="bold" color="white" textTransform="uppercase" letterSpacing="wide" textAlign="center">
//                   E-COMMERCE
//                 </Text>
//               </HStack>
//             </VStack>

//             <VStack spacing={4} p={8} borderRight="1px solid" borderColor="gray.800">
//               <Box fontSize="2xl">🏥</Box>
//               <HStack>
//                 <Box w={2} h={2} bg="green.500" borderRadius="full" />
//                 <Text fontSize="sm" fontWeight="bold" color="white" textTransform="uppercase" letterSpacing="wide" textAlign="center">
//                   HEALTHCARE
//                 </Text>
//               </HStack>
//             </VStack>

//             <VStack spacing={4} p={8}>
//               <Box fontSize="2xl">🎓</Box>
//               <HStack>
//                 <Box w={2} h={2} bg="green.500" borderRadius="full" />
//                 <Text fontSize="sm" fontWeight="bold" color="white" textTransform="uppercase" letterSpacing="wide" textAlign="center">
//                   EDUCATION
//                 </Text>
//               </HStack>
//             </VStack>
//           </Grid>

//           {/* Testimonial */}
//           <Box maxW="4xl" mx="auto" py={16}>
//             <VStack spacing={8}>
//               <Text fontSize="2xl" color="white" lineHeight="1.4" textAlign="center" fontWeight="medium">
//                 "I'm convinced modern web applications will become a self-evident part of next generation 
//                 digital transformation policies at larger companies. In part, because it allows 
//                 us to objectively measure and use performance as a key indicator."
//               </Text>
//               <VStack spacing={2}>
//                 <Text fontSize="xl" fontWeight="bold" color="white">
//                   ALEX THOMPSON
//                 </Text>
//                 <Text color="green.500" fontSize="sm">
//                   CTO, TechStart Solutions
//                 </Text>
//                 <Text color="gray.400" fontSize="sm" textDecoration="underline" cursor="pointer">
//                   Explore our web development solutions →
//                 </Text>
//               </VStack>
//             </VStack>
//           </Box>
//         </VStack>
//       </Box>

//       {/* Simplified Footer - Contact Left, Nav Right */}
//       <Box py={16} px={4} borderTop="1px solid" borderColor="gray.800" w="100%">
//         <HStack spacing={64} align="start" justify="start" maxW="5xl" mx="auto">
//           {/* Contact Section - Left Side */}
//           <VStack align="start" spacing={6}>
//             <Text fontSize="lg" fontWeight="bold" color="white" textTransform="uppercase" letterSpacing="wide">
//               CONTACT
//             </Text>
//             <VStack align="start" spacing={2}>
//               <Text color="gray.300" fontSize="sm">Clover Ridge Technologies</Text>
//               <Text color="gray.300" fontSize="sm">Remote Team</Text>
//               <Text color="gray.300" fontSize="sm">United States</Text>
//               <Text color="gray.300" fontSize="sm">hello@cloverridgetech.com</Text>
//             </VStack>
//           </VStack>

//           {/* Navigation Links - Right Side in Column */}
//           <VStack align="start" spacing={3}>
//             <Text color="white" fontSize="sm" textTransform="uppercase" letterSpacing="wide">PROJECTS</Text>
//             <Text color="white" fontSize="sm" textTransform="uppercase" letterSpacing="wide">ABOUT</Text>
//             <Text color="white" fontSize="sm" textTransform="uppercase" letterSpacing="wide">ENGINEERS</Text>
//             <Text color="white" fontSize="sm" textTransform="uppercase" letterSpacing="wide">ARTICLES</Text>
//           </VStack>
//         </HStack>

//         <Box mt={16} pt={8} borderTop="1px solid" borderColor="gray.800" maxW="5xl" mx="auto">
//           <HStack justify="space-between" align="center" flexWrap="wrap">
//             <HStack spacing={6} flexWrap="wrap">
//               <Text color="gray.400" fontSize="xs">Portfolio</Text>
//               <Text color="gray.400" fontSize="xs">Articles</Text>
//               <Text color="gray.400" fontSize="xs">Privacy & Cookie Statement</Text>
//               <Text color="gray.400" fontSize="xs">Code Of Conduct</Text>
//             </HStack>
//             <HStack spacing={6} flexWrap="wrap">
//               <Text color="gray.400" fontSize="xs">EST. 2020</Text>
//               <Text color="gray.400" fontSize="xs">REMOTE TEAM</Text>
//               <Text color="gray.400" fontSize="xs">MODERN STACK</Text>
//             </HStack>
//           </HStack>
//         </Box>
//       </Box>
//     </Box>
//   );
// }

// export default App;